export const FolderCapacityModel = Symbol.for('FolderCapacityModel');
